import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EventsState } from './events.state';

export const selectEventsState = createFeatureSelector<EventsState>('events');

export const selectUpcomingEvents = createSelector(selectEventsState, (state) => state.upcomingEvents);
export const selectPublicUpcomingEvents = createSelector(selectUpcomingEvents, (events) =>
  events.filter((event) => !event?.private),
);
export const selectUpcomingEventsPagination = createSelector(selectEventsState, (state) => state.upcomingEventsPagination);
export const selectInPreparationEvents = createSelector(selectEventsState, (state) => state.inPreparationEvents);
export const selectPublicInPreparationEvents = createSelector(selectInPreparationEvents, (events) =>
  events.filter((event) => !event?.private),
);
export const selectInPreparationEventsPagination = createSelector(selectEventsState, (state) => state.inPreparationEventsPagination);
export const selectPastEvents = createSelector(selectEventsState, (state) => state.pastEvents);
export const selectPastEventsPagination = createSelector(selectEventsState, (state) => state.pastEventsPagination);
export const selectEventsLoading = createSelector(selectEventsState, (state) => state.loading);
export const selectLoadingMoreUpcomingEvents = createSelector(selectEventsState, (state) => state.loadingMoreUpcomingEvents);
export const selectLoadingMoreInPreparationEvents = createSelector(selectEventsState, (state) => state.loadingMoreInPreparationEvents);
export const selectLoadingMorePastEvents = createSelector(selectEventsState, (state) => state.loadingMorePastEvents);
export const selectEventsError = createSelector(selectEventsState, (state) => state.error);

export const selectHasMoreUpcomingEvents = createSelector(
  selectUpcomingEventsPagination,
  (pagination) => pagination.currentPage < pagination.totalPages,
);

export const selectHasMorePastEvents = createSelector(
  selectPastEventsPagination,
  (pagination) => pagination.currentPage < pagination.totalPages,
);

export const selectHasMoreInPreparationEvents = createSelector(
  selectInPreparationEventsPagination,
  (pagination) => pagination.currentPage < pagination.totalPages,
);
